import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGOUT,
  DISMISS_MESSAGE,
  REMOVE_DEVICE_EXPIRY,
  RESET_PRODA_INFO,
  REMOVE_CERTIFICATE_EXPIRY_WARNING
} from "../constants/auth";

export const loginUser = data => ({
  type: LOGIN,
  payload: data
});

export const loginUserSuccess = data => ({
  type: LOGIN_SUCCESS,
  payload: data
});

export const loginUserError = data => ({
  type: LOGIN_ERROR,
  payload: data
});

export const logOutUser = () => ({
  type: LOGOUT
});

export const dismissMessage = () => ({
  type: DISMISS_MESSAGE
});

export const removeIsPRODADeviceExpiryWarning = () => ({
  type: REMOVE_DEVICE_EXPIRY
});

export const resetPRODAInfo = data => ({
  type: RESET_PRODA_INFO,
  payload: data
});

export const removeCertificateExpiryWarning = data => ({
  type: REMOVE_CERTIFICATE_EXPIRY_WARNING,
  payload: data
});
